
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';

import { sharedState } from '../../../../framework/state';
import { getResource, postResource, putResource } from '../../../../framework/client/resource';
import { getDatabaseOptions, OptionValue } from '../../../../framework/service/options';
import { FileMeta } from '../../../../../common/application/model/FileMeta';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import TextField from '../../../../framework/fields/TextField.vue';
import TextAreaField from '../../../../framework/fields/TextAreaField.vue';
import { ValidationObserver } from 'vee-validate';
import { Option } from '../../../../../common/framework/model/Option';

@Component({
    components: {
        TextField,
        ValidationObserver,
        Multiselect,
        TextAreaField,
    },
})
export default class EditDocument extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.FILE_META;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        total: 0,
        loading: false,
        file: null as { name: string; size: number; type: string; lastModified: number; uploadName: string } | null,
        categoryOptions: [] as OptionValue[],
        row: {} as FileMeta,
        validBtn: true,
        isTouched: false,
    };

    // Functions
    async mounted() {
        this.local.loading = true;
        await this.loadAsyncData();
        this.local.loading = false;
    }

    async loadAsyncData() {
        this.local.row = (await getResource<FileMeta>(this.resourceType, this.id))!!;
        if (!this.local.row) {
            this.local.row = {} as FileMeta;
        }

        this.local.categoryOptions = (await getDatabaseOptions('DocumentCategory', this)).filter(
            ({ id }) => id !== undefined,
        );
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    async saveResource(goBack: boolean) {
        this.local.row = { ...this.local.row, modified: new Date() };
        await putResource<FileMeta>(this.resourceType, this.id, this.local.row);

        if (goBack) {
            this.back();
        }
    }

    async addTag(label: string) {
        const newOption = {
            id: '',
            type: 'document-category',
            key: label,
            index: 1,
            metadata: {
                labelEn: label,
                labelFi: label,
            },
            vatRate: null,
            created: new Date(),
            modified: new Date(),
        };
        this.local.row = { ...this.local.row, category: label };
        const option = await postResource<Option>('option', newOption);
        this.local.categoryOptions.push({
            id: option.id,
            label: option.key,
        });
    }

    @Watch('local.row')
    async isValidBtn() {
        if (this.local.row.name && this.local.row.category) {
            this.local.validBtn = false;
        }
    }

    onTouch() {
        this.local.isTouched = true;
    }

    back() {
        this.$router.go(-1);
    }
}
